/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live F1 World Championship standings for drivers and constructors — updated after every race. Follow who’s leading the championship, track podium streaks, and see how on-track performance connects to fantasy scoring.`)
};

const es_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación en vivo del Campeonato Mundial de F1 para pilotos y constructores — actualizada después de cada carrera. Sigue quién lidera el campeonato, rastrea rachas de podio y observa cómo el rendimiento en pista se conecta con la puntuación de fantasy.`)
};

const de_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-F1-WM-Wertung für Fahrer und Konstrukteure — aktualisiert nach jedem Rennen. Verfolge, wer die Meisterschaft anführt, beobachte Podiumsserien und sieh, wie die Streckenleistung mit der Fantasy-Wertung zusammenhängt.`)
};

const nl_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live F1 WK-stand voor coureurs en constructeurs — bijgewerkt na elke race. Volg wie het kampioenschap leidt, bekijk podiumreeksen en ontdek hoe baanprestaties samenhangen met fantasy-scoring.`)
};

const fr_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classement en direct du Championnat du Monde F1 pour les pilotes et constructeurs — mis à jour après chaque course. Suivez qui mène le championnat, observez les séries de podiums et découvrez comment la performance en piste influence le scoring fantasy.`)
};

const it_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifica in tempo reale del Campionato Mondiale F1 per piloti e costruttori — aggiornata dopo ogni gara. Segui chi guida il campionato, monitora le serie di podi e scopri come le prestazioni in pista influenzano il punteggio fantasy.`)
};

const pt_br2_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação ao vivo do Campeonato Mundial de F1 para pilotos e construtores — atualizada após cada corrida. Acompanhe quem lidera o campeonato, observe sequências de pódios e veja como o desempenho na pista se conecta com a pontuação fantasy.`)
};

const pt_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação ao vivo do Campeonato Mundial de F1 para pilotos e construtores — atualizada após cada corrida. Acompanhe quem lidera o campeonato, observe séries de pódios e veja como o desempenho na pista se conecta com a pontuação fantasy.`)
};

const ja_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1世界選手権のドライバーとコンストラクターのリアルタイム順位表 — 各レース後に更新。チャンピオンシップのリーダー、表彰台の連続記録を追跡し、サーキットでのパフォーマンスがファンタジースコアリングにどう影響するかを確認しましょう。`)
};

const zh_f1_standings_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1世界锦标赛车手和车队积分榜实时更新 — 每场比赛后更新。追踪谁在领跑锦标赛、关注领奖台连续纪录，了解赛道表现如何影响梦幻积分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_intro", locale)
	if (locale === "en") return en_f1_standings_intro(inputs)
	if (locale === "es") return es_f1_standings_intro(inputs)
	if (locale === "de") return de_f1_standings_intro(inputs)
	if (locale === "nl") return nl_f1_standings_intro(inputs)
	if (locale === "fr") return fr_f1_standings_intro(inputs)
	if (locale === "it") return it_f1_standings_intro(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_intro(inputs)
	if (locale === "pt") return pt_f1_standings_intro(inputs)
	if (locale === "ja") return ja_f1_standings_intro(inputs)
	return zh_f1_standings_intro(inputs)
};